/* eslint-disable */
import PasswordStrength from '@/scripts/blocks/form/password-strength';
import validate from '@/scripts/blocks/form/validator';
import connectInputs from '@/scripts/blocks/form/connect-inputs';

export default class InputBlock {
  constructor(inputBlock) {
    this.element = inputBlock;
    this.type = this.element.dataset.type;
    this.required = this.element.dataset.required;
    this.input = this.type === 'radio' || this.type === 'checkbox'
      ? Array.from(this.element.querySelectorAll('[data-role="input"]'))
      : this.element.querySelector('[data-role="input"]');
    this.valid = true;
    this.label = this.element.querySelector('[data-role="label"]');
    this.error = this.element.querySelector('[data-role="error"]');
    this.controller = this.element.dataset.controller || null;
    if (this.controller && !this.element.dataset.connected) {
      const controller = this.element.closest('form').elements[this.controller];
      this.element.dataset.connected = true;
      connectInputs(controller, this.element);
    }
    if (this.type !== 'radio' && this.type !== 'checkbox') {
      this.initAnimation();
    }

    if (this.type === 'password') {
      this.livePasswordValidation();
    }

    this.activeClass = 'is-active';
  }

  livePasswordValidation() {
    const $input = $(this.input);
    const $passwordElement = $(this.element).find('[data-role="password-strength"]');
    if ($input.data('validation')) return;
    $input.data('validation', true);
    const passwordValidator = new PasswordStrength($passwordElement[0]);
    $input.on('focusin focusout', (e) => {
      $passwordElement.toggleClass('is-active', e.type === 'focusin');
    });

    $(this.input).on('change input', (e) => {
      const val = e.target.value;
      passwordValidator.validate(val);
    });
  }

  validate() {
    const {
      requiredMessage, validationMessage, required, validation,
    } = this.element.dataset;
    let validationResult = {
      valid: true,
      error: '',
    };
    if ((this.type === 'radio' || this.type === 'checkbox')) {
      validationResult.valid = this.required ? !!this.input.filter(el => el.checked).length : true;
      validationResult.error = validationResult.valid ? '' : requiredMessage;

    } else {
      const field = {
        value: this.input.value,
        name: this.label.innerText,
        required,
        validation,
        validationMessage,
        requiredMessage,
      };
      if (validation === 'repassword') {
        field.equalTo = this.element.closest('form').elements.password.value;
      }

      validationResult = this.input.disabled ? validationResult : validate(field);
    }
    this.valid = validationResult.valid;
    $(this.element).toggleClass('is-invalid', !this.valid);
    this.error.innerText = $.trim(validationResult.error);
    this.element.setAttribute('title', validationResult.error);
  }

  initAnimation() {
    this.element.classList.toggle(this.activeClass, !!this.input.value);
    ['focusin', 'input', 'change', 'focusout'].forEach((event) => {
      this.input.addEventListener(event, (e) => {
        this.element.classList.toggle(
          this.activeClass,
          !!this.input.value
          || e.type !== 'focusout', // keep input in active state if it is focused and has no value
        );
      });
    });
  }

  reset() {
    this.input.value = '';
    this.element.classList.remove(this.activeClass);
  }
}



// WEBPACK FOOTER //
// ./scripts/blocks/form/components/InputBlock/InputBlock.js